import { getFlagFromTimezone, getTimezoneAbbreviation } from '@/lib/utils';

export const TimezoneWithFlag = ({ timezone }: { timezone?: string }) => {
  if (!timezone) return <></>;
  const flag = getFlagFromTimezone(timezone);
  const abbreviation = getTimezoneAbbreviation(timezone);
  return (
    <p className="font-medium text-sm leading-[22px] text-magical-moonlight-d1">
      {flag ? <span className="text-lg">{flag} </span> : null}
      All mentioned times are in{' '}
      <span className="font-bold text-magical-moonlight-d2">
        {timezone}
        {abbreviation ? ` (${abbreviation})` : ''}
      </span>
    </p>
  );
};
